export default __webpack_public_path__ + "static/media/Immersive_Exhibition_Event_small.40f6ba3b.png";